import { Descope } from '@descope/react-sdk';
import { Box, Container, Paper, styled, SvgIcon, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import backgroundImg from '../assets/background.png';

const centeredProps = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  };

const CenteredBox = styled(Box, {
    name: 'MuiBox',
    slot: 'root',
  })(() => ({ ...centeredProps }));

export default function Login() {
    const navigate = useNavigate();

    return (
        <CenteredBox
        data-testid="login-page"
        sx={{
          height: '100vh',
          backgroundImage: `url(${backgroundImg})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
        flexDirection="column"
      >
        <Container maxWidth="sm">
          <Paper
            elevation={3}
            sx={{
              padding: 2,
              height: '60vh',
              borderRadius: 8,
              boxSizing: 'border-box',
              border: `1px solid #E2E9F3`,
            }}
          >
            <CenteredBox sx={{ pt: 8 }}>
              <Typography fontSize={24} fontWeight={600}>
                Login
              </Typography>
            </CenteredBox>
            <Descope
                flowId="sign-in-password"
                onSuccess={() => navigate(`/`)}
                onError={() => console.log('Could not log in!')}
            />
          </Paper>
        </Container>
      </CenteredBox>
    )
}
